<template>
  <Label
    v-if="brandingPreview"
    class="flex items-center justify-center text-center text-white p-2 bg-ochre"
  >
    Only you can see this branding preview. To enable it for your clients,
    please
    <a
      class="underline ml-1"
      @click="
        navigateToTierUpgrade({
          source: 'Branding Preview Banner',
          tierFeature: 'BRANDING',
          tier: getMinimumTier('BRANDING'),
          interval: designer?.subscriptionInterval,
        })
      "
    >
      upgrade to our {{ prettyEligibleTiers('BRANDING') }} tier
    </a>
    .
    <span class="underline cursor-pointer ml-1" @click="reset">
      Reset to the Spoak branding
    </span>
    .
  </Label>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { usePermission, useTiers, useTierUpgrade } from './tiers'
import { useDesignerBranding } from '/@/data/designer/branding'
import { useCurrentDesigner } from '/@/data/designer/current'

const { getMinimumTier, prettyEligibleTiers } = useTiers()
const { navigateToTierUpgrade } = useTierUpgrade()
const { designer } = useCurrentDesigner()
const designerBranding = useDesignerBranding()
const route = useRoute()
const brandingPermission = usePermission('BRANDING')

const brandingPreview = computed(
  () =>
    // If the user is not designer tier but is viewing a page that has
    // their branding then the branding is temporary and we are only
    // letting them preview them.
    route.meta?.hasBranding &&
    designerBranding.hasBranding &&
    designer.value?.id === designerBranding.id &&
    !brandingPermission.hasPermission.value,
)

function reset() {
  designerBranding.setBranding({
    logoImageUrl: null,
    primaryColor: null,
    secondaryColor: null,
    backgroundColor: null,
  })
}
</script>

<style lang="scss" scoped></style>
